import { useState } from 'react';

const readSearchParam = (name: string) =>
  new URLSearchParams(window.location.search).get(name);

const writeSearchParam = (name: string, value: string | null) => {
  const url = new URL(window.location.href);
  if (value === null) {
    url.searchParams.delete(name);
  } else {
    url.searchParams.set(name, value);
  }
  window.history.replaceState(window.history.state, '', url);
};

export const useSearchParamState = (name: string) => {
  const [value, setValue] = useState(() => readSearchParam(name));

  const onValueChange = (nextValue: string | null) => {
    setValue(nextValue);
    writeSearchParam(name, nextValue);
  };

  return [value, onValueChange] as const;
};
